export default function() {
    return { type: 'SET_PROFILE_FAILED' };
}